import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import HomePage from "@/pages/HomePage";
import ResultPage from "@/pages/ResultPage";
import ScrapedDataPage from "@/pages/ScrapedDataPage";
import UploadPage from "@/pages/UploadPage";
import BulkUploadPage from "@/pages/BulkUploadPage";
import InfoUploadPage from "@/pages/InfoUploadPage";
import CategoryUploadPage from "@/pages/CategoryUploadPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import PricingPage from "@/pages/PricingPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/result" element={<ResultPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          
          {/* Admin Auth */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          
          {/* Protected Admin Routes */}
          <Route path="/admin/dashboard" element={
            <ProtectedRoute><AdminDashboardPage /></ProtectedRoute>
          } />
          <Route path="/admin/upload" element={
            <ProtectedRoute><UploadPage /></ProtectedRoute>
          } />
          <Route path="/admin/bulk-upload" element={
            <ProtectedRoute><BulkUploadPage /></ProtectedRoute>
          } />
          <Route path="/admin/charts" element={
            <ProtectedRoute><ScrapedDataPage /></ProtectedRoute>
          } />
          <Route path="/admin/info-upload" element={
            <ProtectedRoute><InfoUploadPage /></ProtectedRoute>
          } />
          <Route path="/admin/category-upload" element={
            <ProtectedRoute><CategoryUploadPage /></ProtectedRoute>
          } />
          
          {/* Legacy routes redirect to admin */}
          <Route path="/upload" element={<AdminLoginPage />} />
          <Route path="/bulk-upload" element={<AdminLoginPage />} />
          <Route path="/scraped-data" element={<AdminLoginPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
